import React from 'react';
import RDSection from '../components/RDSection';
import Footer from '../components/Footer';
import '../styles/HomePage.css';

const CollaborationPage = () => {
  const handleNavigation = (section) => {
    if (section === 'rd-collaboration') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      document.getElementById(section)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="collaboration-page pt-20">
      <RDSection />
      <Footer onNavigate={handleNavigation} />
    </div>
  );
};

export default CollaborationPage;
